/**
 * ******************************************************
 * Copyright (C) 2019-2021 VMware, Inc. All rights reserved.
 * *******************************************************
 *
 * @format
 */

/**
 * GetApplicationConnectionRedirectHandler.js--
 *
 *      inherited Class to handle <get-application-connection-redirect>
 */

import RedirectHandler from "./redirectHandler";

export default function GetApplicationConnectionRedirectHandler() {
   this.requestTag = "get-application-connection-redirect"; // the XML request tag name
   this.responseTag = "application-connection-redirect"; // the XML response tag name
}

// inherits RedirectHandler prototype
GetApplicationConnectionRedirectHandler.prototype = new RedirectHandler();

// constructor
GetApplicationConnectionRedirectHandler.constructor = GetApplicationConnectionRedirectHandler;
